import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ProfissionalAtivoMaisMedicos,
  ProfissionalDesligadoMaisMedicos,
  ValidadeCrm,
} from '../models/response/mais-medicos.model';

@Injectable({
  providedIn: 'root',
})
export class MaisMedicosService {
  private readonly apiUrl = `${environment.fullApiUrl}/mais-medicos`;
  private readonly http = inject(HttpClient);

  consultarProfissionalAtivo(
    cpf: string,
  ): Observable<ProfissionalAtivoMaisMedicos> {
    return this.http.get<ProfissionalAtivoMaisMedicos>(
      `${this.apiUrl}/profissional-ativo/${cpf}`,
    );
  }

  consultarProfissionalDesligado(
    cpf: string,
  ): Observable<ProfissionalDesligadoMaisMedicos> {
    return this.http.get<ProfissionalDesligadoMaisMedicos>(
      `${this.apiUrl}/profissional-desligado/${cpf}`,
    );
  }

  validarCrm(cpf: string, crm: string, uf: string): Observable<ValidadeCrm> {
    const params = new HttpParams()
      .set('cpf', cpf)
      .set('crm', crm)
      .set('uf', uf);
    return this.http.get<ValidadeCrm>(`${this.apiUrl}/validate-crm`, {
      params,
    });
  }
}
